import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import firebase from 'firebase'
const fb = require('@/firebaseConfig.js')

import Home from '@/views/Home'
import Login from '@/views/Login'
import Welcome1 from '@/views/Onboarding/Welcome1'
import Events from '@/views/Events'
import EventDetail from '@/views/EventDetail'
import About from '@/views/About'
import News from '@/views/News'
import NewsDetail from '@/views/NewsDetail'
import Members from '@/views/Members'
import Account from '@/views/Account/Account'
import Settings from '@/views/Account/Settings'
import Saved_Events from '@/views/Account/Saved_Events'
import Listings from '@/views/Listings'
import Workshops from '@/views/Workshops'
import WorkshopDetail from '@/views/WorkshopDetail'
import WorkshopMeeting from '@/views/WorkshopMeeting'
import Leaderboard from '@/views/Leaderboard'
import City from '@/views/City'
import UserDetail from '@/views/UserDetail'

// Beta
import Eats from '@/views/Eats/Eats'
import Resources from '@/views/Resources'
import Chat from '@/views/Chat'
import Videos from '@/views/Videos'
import Auth from '@/views/Auth'
import Tests from '@/views/Tests/Tests'
import Posts from '@/views/Posts/Posts'
import Stories from '@/views/Stories/Stories'
import StoriesDetail from '@/views/Stories/StoriesDetail'
import Friends from '@/views/Friends'

// Admin
import Admin from '@/views/Admin/Admin'
import AdminTest from '@/views/Admin/Test'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/'
		},
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				title: 'Login',
				hideForAuth: true
			}
		},
		{
			path: '/register',
			name: 'Register',
			component: Login,
			meta: {
				title: 'Register',
				hideForAuth: true
			}
		},
		{
			path: '/welcome1',
			name: 'Welcome1',
			component: Welcome1,
			meta: {
				title: 'Welcome 1'
			}
		},
		{
			path: '/events',
			name: 'Events',
			component: Events
		},
		{
			path: '/events/:id',
			name: 'EventDetailed',
			component: EventDetail
		},
		{
			path: '/about',
			name: 'About Us',
			component: About
		},
		{
			path: '/news',
			name: 'News',
			component: News
		},
		{
			path: '/news/:id',
			name: 'NewsDetailed',
			component: NewsDetail
		},
		{
			path: '/members',
			name: 'Members',
			component: Members
		},
		{
			path: '/admin',
			name: 'Admin',
			component: Admin
		},
		{
			path: '/admin/test',
			name: 'Admin Test',
			component: AdminTest
		},
		{
			path: '/account',
			name: 'Account',
			component: Account,
			meta: {
				requiresAuth: true,
				hasSubNav: true
			}
		},
		{
			path: '/settings',
			name: 'Settings',
			component: Settings,
			meta: {
				requiresAuth: true,
				hasSubNav: true
			}
		},
		{
			path: '/savedevents',
			name: 'Saved Events',
			component: Saved_Events,
			meta: {
				requiresAuth: true,
				hasSubNav: true
			}
		},
		{
			path: '/listings',
			name: 'Listings',
			component: Listings,
			meta: {
				title: 'Listings'
			}
		},
		{
			path: '/workshops',
			name: 'Workshops',
			component: Workshops,
			meta: {
				title: 'Workshops'
			}
		},
		{
			path: '/workshops/:id',
			name: 'Workshop Detailed',
			component: WorkshopDetail
		},
		{
			path: '/meeting',
			name: 'Meeting',
			component: WorkshopMeeting
		},
		{
			path: '/leaderboard',
			name: 'Leaderboard',
			component: Leaderboard,
			meta: {
				title: 'Leaderboard'
			}
		},
		{
			path: '/city/:id',
			name: 'City',
			component: City,
			meta: {
				title: 'City'
			}
		},
		{
			path: '/user/:id',
			name: 'User',
			component: UserDetail
		},
		{
			path: '/auth',
			name: 'Auth',
			component: Auth
		},
		// Beta
		{
			path: '/eats',
			name: 'Eats',
			component: Eats,
			meta: {
				title: 'Eats'
			}
		},
		{
			path: '/resources',
			name: 'Resources',
			component: Resources,
			meta: {
				title: 'Resources'
			}
		},
		{
			path: '/chat',
			name: 'Chat',
			component: Chat,
			meta: {
				title: 'Chat'
			}
		},
		{
			path: '/tests',
			name: 'Tests',
			component: Tests,
			meta: {
				title: 'Tests'
			}
		},
		{
			path: '/videos',
			name: 'Videos',
			component: Videos,
			meta: {
				title: 'Videos'
			}
		},
		{
			path: '/stories',
			name: 'Stories',
			component: Stories,
			meta: {
				title: 'Stories'
			}
		},
		{
			path: '/stories/:id',
			name: 'StoriesDetail',
			component: StoriesDetail,
			meta: {
				title: 'Stories Detail'
			}
		},
		{
			path: '/posts',
			name: 'Posts',
			component: Posts,
			meta: {
				title: 'Posts'
			},
			// children: [
			// 	{
			// 		path: '/posts/:id',
			// 		name: 'Post',
			// 		component: Posts,

			// 	}
			// ]
		},
		{
			path: '/friends',
			name: 'Friends',
			component: Friends,
			meta: {
				title: 'Friends'
			}
		}
	]
})

router.beforeEach((to, from, next) => {
    firebase.auth().onAuthStateChanged(function(user){

		// Not Logged In
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!user) {
                next({ path: '/login' })
            } else {
                next()
            }
        } else {
            next()
        }

		// Logged In Users
        if (to.matched.some(record => record.meta.hideForAuth)) {
            if (user) {
                next({ path: '/welcome1' })
            } else {
                next()
            }
        } else {
            next()
        }
    })
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js